import { Component, OnInit } from '@angular/core';
import { IDashboardMidwifePayload, ISearchMidwifeBody } from 'src/app/models/dashboard.models';
import { HomeService } from 'src/app/services/home.service';

@Component({
  selector: 'app-profile-list',
  templateUrl: './profile-list.component.html',
  styleUrls: ['./profile-list.component.scss']
})
export class ProfileListComponent implements OnInit {

  midwifes: Array<IDashboardMidwifePayload> = [];
  body: ISearchMidwifeBody;
  showLoadMore: boolean;
  LIMIT: number = 15;
  loading = false;

  constructor(public homeService: HomeService) { }

  ngOnInit(): void {
    this.midwifes = [];
    this.showLoadMore = true;
    this.body = {
      sortingCriteria: "A_Z_ASC",
      offset: 0,
      limit: this.LIMIT
    }
    this.getMidwifeList();
  }

  getMidwifeList(){
    this.loading = true;
    this.body.offset = this.midwifes.length;
    this.homeService.searchMidwife(this.body)
    .subscribe((res)=>{
      this.loading = false;
      if(res.payload.length < this.LIMIT)
      {
        this.showLoadMore = false;
      }
      this.midwifes = this.midwifes.concat(res.payload);
    },err=>{
      console.error(err);
    });
  }
}